import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import React from 'react';

import { baseTheme } from '../../../../theme';

import { IPostActionButton } from '../interfaces';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.main,
      paddingBottom: '5px',
      textAlign: 'center',
      '&:hover': {
        paddingBottom: '0',
        borderBottom: 'solid 5px',
        borderColor: theme.palette.primary.main,
      },
    },
    publicColor: {
      color: theme.palette.primary.main,
    },
    privateColor: {
      color: theme.palette.secondary.main,
    },
    staticColor: {
      color: theme.palette.text.primary,
    },
  }),
);

interface ITipsFaqActionButton extends IPostActionButton {
  postType?: string | null;
}

export default function FaqActionButton(props: ITipsFaqActionButton) {
  const { iconOnly, postType = null, className = null } = props;
  const classes = useStyles(baseTheme);
  const history = useHistory();

  const handleClick = (event: any) => {
    event.preventDefault();
    history.push('/admin/tips-faqs');
  };

  const colorSelector = postType === 'Public'
    ? classes.publicColor
    : postType === 'Private'
      ? classes.privateColor
      : classes.staticColor;

  return iconOnly ?
    (<HelpOutlineIcon onClick={handleClick}
      className={`${className}`} />) :
    (
      <Grid
        item
        container
        direction="column"
        xs={1}
        className={`${classes.root} ${colorSelector} ${className}`}
        onClick={handleClick}>
        <Grid item>
          <HelpOutlineIcon />
        </Grid>
        <Grid item>
          Tips/FAQs
        </Grid>
      </Grid>
    );
}
